import servise from '@/router/axios'

/**
 * 分页查询创意集列表
 */
export const getCreativeSetList = (params) => {
  return servise({
    url: '/creativeSet/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID查询创意集
 */
export const getCreativeSetById = (id) => {
  return servise({
    url: `/creativeSet/${id}`,
    method: 'get'
  })
}

/**
 * 获取创意集绑定的创意列表
 */
export const getCreativeListBySetId = (id) => {
  return servise({
    url: `/creativeSet/${id}/creativeList`,
    method: 'get'
  })
}

/**
 * 新增创意集
 */
export const addCreativeSet = (data) => {
  return servise({
    url: '/creativeSet/add',
    method: 'post',
    data
  })
}

/**
 * 修改创意集
 */
export const updateCreativeSet = (data) => {
  return servise({
    url: '/creativeSet/update',
    method: 'put',
    data
  })
}

/**
 * 删除创意集
 */
export const deleteCreativeSet = (idList) => {
  return servise({
    url: '/creativeSet/delete',
    method: 'delete',
    params: { idList }
  })
}
